import React, { useEffect } from 'react'
import comfort1 from '../../static/images/woodsneaker/comfort-1.png'
import footbed from '../../static/images/woodsneaker/footbed.png'
import newsletter from '../../static/images/woodsneaker/newsletter.png'
import quote from '../../static/images/woodsneaker/qoute.png'
import sec3Leaves from '../../static/images/woodsneaker/sec3-leaves.png'
import sec5Leaves from '../../static/images/woodsneaker/sec5-leaves.png'
import stayCool from '../../static/images/woodsneaker/stay-cool.png'
import upsell from '../../static/images/woodsneaker/upsell.png'
import registerAnimations from './registerAnimations'

import staticBgSec5 from '../../static/images/woodsneaker/sec5-bg.jpg'
import staticBgSec5Mobile from '../../static/images/woodsneaker/sec5-bg-sm.jpg'

import staticBgSec9 from '../../static/images/woodsneaker/sec5-bg.jpg'
import staticBgSec9Mobile from '../../static/images/woodsneaker/sec5-bg-sm.jpg'

import staticBgSec10 from '../../static/images/woodsneaker/sec9-bg.jpg'
import staticBgSec10Mobile from '../../static/images/woodsneaker/sec9-sm-bg.jpg'
import TrustpilotWidget from '../TrustpilotWidget/TrustpilotWidget'

const LandingPageWoodSneaker2 = ({
  sec5Heading,
  sec5Content,
  sec5ImageMobile,
  sec5Image,
  sec5Button1Text,
  sec5Button2Text,
  sec5Button1Url,
  sec5Button2Url,
  sec6Heading,
  sec6Content,
  sec6Button1Text,
  sec6Button2Text,
  sec6Button1Url,
  sec6Button2Url,
  sec7Heading,
  sec7Content,
  sec7Button1Text,
  sec7Button2Text,
  sec7Button1Url,
  sec7Button2Url,
  sec8Heading,
  sec8Content,
  sec9Content,
  sec9ImageMobile,
  sec9Image,
  sec9Button1Text,
  sec9Button2Text,
  sec9Button1Url,
  sec9Button2Url,
  sec10Content,
  sec10ImageMobile,
  sec10Image,
  sec10ButtonText,
  sec10ButtonUrl,
  sec11Content,
  sec11Button1Text,
  sec11Button2Text,
  sec11Button1Url,
  sec11Button2Url,
}) => {
  useEffect(() => {
    registerAnimations()
  }, [])

  return (
    <div className="landingpage-woodcross">
      <style>
        {`
          .sec5 {
            background-image: url(${sec5ImageMobile});
          }

          @media (min-width: 768px) {
            .sec5 {
              background-image: url(${sec5Image});
            }
          }
        `}
      </style>

      <section className="sec sec5 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <article className="content col-12 col-sm-9 col-md-6 col-lg-6 col-xl-6 ml-auto text-right align-self-center">
              <div className="pl-5 pl-md-0 ml-4 ml-md-0">{sec5Heading}</div>
              <div className="pl-5 pl-md-0 ml-4 ml-md-0">{sec5Content}</div>
              <p className="d-flex text-center text-md-right btn-group mb-0 d-md-block ">
                <a
                  href={sec5Button1Url}
                  className="btn btn-dark mb-1 mr-2 btn-size-md"
                >
                  {sec5Button1Text}
                </a>{' '}
                <a
                  href={sec5Button2Url}
                  className="btn btn-dark mb-1 ml-2 btn-size-md"
                >
                  {sec5Button2Text}
                </a>
              </p>
            </article>
          </div>
        </div>
      </section>
      <section className="sec sec6 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <article className="content col-12 col-sm-9 col-md-7 col-lg-7 col-xl-7 mr-auto  align-self-start">
              {sec6Heading}
              <p className="pr-5 ">{sec6Content}</p>

              <p className="btn-group pt-4 mb-0 text-center">
                <a
                  href={sec6Button1Url}
                  className="btn btn-dark mb-1 mr-2 btn-size-md"
                >
                  {sec6Button1Text}
                </a>{' '}
                <a
                  href={sec6Button2Url}
                  className="btn btn-dark mb-1 ml-2 btn-size-md"
                >
                  {sec6Button2Text}
                </a>
              </p>
            </article>
            <figure className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 mr-auto position-static">
              <p className="hide animated stay-cool">
                <img src={stayCool} className="stay-cool" alt="" />
              </p>
            </figure>
          </div>
        </div>
        <img src={sec5Leaves} alt="" className="leaves sec6-leaves" />
      </section>
      <section className="sec sec7 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <div className=" col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7 ml-auto text-center align-self-center">
              <figure className="d-inline-block comfort">
                <img
                  src={comfort1}
                  className="comfort-img comfort-1 hide animated"
                  alt=""
                />
              </figure>
            </div>
            <article className="content col-12 col-sm-9 col-md-6 col-lg-6 col-xl-5 ml-auto  align-self-center text-right">
              <div className="pl-5 pl-md-0 ">{sec7Heading}</div>
              <div className="pl-5 pl-md-0">{sec7Content}</div>

              <p className="d-flex text-center text-md-right btn-group mb-0 d-md-block ">
                <a
                  href={sec7Button1Url}
                  className="btn btn-light mb-1 mr-2 btn-size-md"
                >
                  {sec7Button1Text}
                </a>{' '}
                <a
                  href={sec7Button2Url}
                  className="btn btn-light mb-1 ml-2 btn-size-md"
                >
                  {sec7Button2Text}
                </a>
              </p>
            </article>
          </div>
        </div>
      </section>
      <section className="sec sec8 footbed bg-dark d-flex position-relative">
        <div className="container d-flex flex-grow-1 position-static">
          <div className="row flex-grow-1">
            <article className="content-2 col-12 col-md-6 col-lg-6 col-xl-5 pt-lg-4 ml-md-auto align-self-center">
              {sec8Heading}
              <div className="mr-xl-4">{sec8Content}</div>
            </article>
            <figure className="col-12 col-md-6  align-self-center position-static">
              <p className="hide animated fadeInLeft">
                <img
                  src={footbed}
                  alt=""
                  className="d-md-block footbed-img hide animated"
                />
              </p>
            </figure>
          </div>
        </div>
      </section>

      <style>
        {`
          .sec5--second {
            background-image: url(${sec9ImageMobile});
          }

          @media (min-width: 768px) {
            .sec5--second {
              background-image: url(${sec9Image});
            }
          }
        `}
      </style>

      <section className="sec sec5 sec5--second d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <article className="content col-12 col-sm-9 col-md-6 col-lg-6 col-xl-5 ml-auto text-right align-self-center">
              {sec9Content}
              <p className="d-flex text-center text-md-right btn-group mb-0 d-md-block ">
                <a
                  href={sec9Button1Url}
                  className="btn btn-dark mb-1 mr-2 btn-size-md"
                >
                  {sec9Button1Text}
                </a>{' '}
                <a
                  href={sec9Button2Url}
                  className="btn btn-dark mb-1 ml-2 btn-size-md"
                >
                  {sec9Button2Text}
                </a>
              </p>
            </article>
          </div>
        </div>
      </section>

      <style>
        {`
          .sec9 {
            background-image: url(${sec10ImageMobile});
          }

          @media (min-width: 568) {
            .sec9 {
              background-image: url(${sec10Image});
            }
          }
        `}
      </style>

      <section className="sec sec9 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <article className="content col-11 col-sm-9 col-md-6 col-lg-6 col-xl-6 ml-auto  pt-xl-5 mt-xl-5 align-self-center text-right">
              {sec10Content}
              <p className="pt-4  mb-0">
                <a
                  href={sec10ButtonUrl}
                  className="btn btn-outline-light mb-1 btn-size-md"
                >
                  {sec10ButtonText}
                </a>
              </p>
            </article>
          </div>
        </div>
        <img src={sec3Leaves} alt="" className="leaves sec3-leaves" />
      </section>
      <section className="sec sec10 py-5 testimonials">
        <div className="container">
          <p className="text-center qoute pb-4">
            <img src={quote} alt="" />
          </p>
        </div>
        <div className="trustBox-widget py-4 py-lg-5 mb-5">
          <div className="container">
            <TrustpilotWidget />
          </div>
        </div>
        <div className="testimonials-products">
          <div className="container">
            <div className="row">
              <figure className="d-none d-md-block col-12 col-md-5">
                <p>
                  <img src={upsell} alt="" />
                </p>
              </figure>
              <article className="content col-12 col-md-7 mb-lg-0 ml-md-auto">
                <h3>{sec11Content}</h3>
                <figure className="d-md-none">
                  <img src={upsell} alt="" />
                </figure>
                <p className="btn-cont mt-5 text-center text-md-left">
                  <a
                    href={sec11Button1Url}
                    className="btn btn-dark  d-md-inline-block mb-3 mr-1"
                  >
                    {sec11Button1Text}
                  </a>
                  <a
                    href={sec11Button2Url}
                    className="btn btn-dark  d-md-inline-block mb-3 ml-sm-3"
                  >
                    {sec11Button2Text}
                  </a>
                </p>
              </article>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

LandingPageWoodSneaker2.defaultProps = {
  sec5Heading: (
    <h1>
      Perfect for <br />
      <strong>the summer.</strong>
    </h1>
  ),
  sec5Content: (
    <p>
      The eucalyptus fibre absorbs around 50% more moisture than cotton and
      effectively wicks it away from the body. The fibres have a pleasantly
      cooling effect in hot weather and ensure an optimal skin climate.
      Therefore our Wood Sneaker is the ideal partner for hot summer days!
    </p>
  ),
  sec5ImageMobile: staticBgSec5Mobile,
  sec5Image: staticBgSec5,
  sec5Button1Text: 'Women',
  sec5Button2Text: 'Men',
  sec5Button1Url: '#',
  sec5Button2Url: '#',
  sec6Heading: (
    <h2>
      Unpleasant odours <br /> <strong>don't stand a chance.</strong>
    </h2>
  ),
  sec6Content: (
    <p>
      Embarrassing situations because of smelly feet? Not with our Wood
      Sneakers. The smooth structure of the eucalyptus fibre prevents the growth
      of bacteria and does not let bad odours arise in the first place.
    </p>
  ),
  sec6Button1Text: 'Women',
  sec6Button2Text: 'Men',
  sec6Button1Url: '#',
  sec6Button2Url: '#',
  sec7Heading: (
    <h2>
      Advanced <br />
      <strong>Grip System. </strong>
    </h2>
  ),
  sec7Content: (
    <p>
      Comfort down to the last detail. The new, extra-light EVA foam provides
      even more cushioning than ordinary EVA material. The Advanced-Grip-System
      with a profiled sole made of bio-rubber provides optimal grip.
    </p>
  ),
  sec7Button1Text: 'Women',
  sec7Button2Text: 'Men',
  sec7Button1Url: '#',
  sec7Button2Url: '#',
  sec8Heading: (
    <h2>
      GIESSWEIN <br /> <strong>Merino Footbed</strong>
    </h2>
  ),
  sec8Content: (
    <p>
      Made from 100% merino wool. An exchangeable footbed made of 100 % merino
      wool. Provides a pleasant soft skin feeling and increased wearing comfort.
    </p>
  ),
  sec9Content: (
    <>
      <h2 className="pl-5 pl-md-0 ml-4 ml-md-0">
        Off to the <br />
        <strong>
          washing <br /> machine.
        </strong>
      </h2>
      <p className="pl-5 pl-md-0 ml-4 ml-md-0">
        You can wash your Wood Sneakers in the washing machine (cold water,
        30°C, wool wash cycle, no fabric softener). Then let the shoes dry in
        the air and do not put them in the dryer.
      </p>
    </>
  ),
  sec9ImageMobile: staticBgSec9Mobile,
  sec9Image: staticBgSec9,
  sec9Button1Text: 'Women',
  sec9Button2Text: 'Men',
  sec9Button1Url: '#',
  sec9Button2Url: '#',
  sec10Content: (
    <>
      <h2>
        Environmental <br /> protection and <br />
        <strong>sustainability.</strong>
      </h2>
      <p>
        Throughout the three generations of our company’s family owned and
        operated business, we’ve learned to combine our knowledge of wool
        craftsmanship with modern, green thinking about the environment and
        animal protection
      </p>
    </>
  ),
  sec10ImageMobile: staticBgSec10Mobile,
  sec10Image: staticBgSec10,
  sec10ButtonText: 'Learn more',
  sec10ButtonUrl: '#',
  sec11Content: (
    <>
      <strong>These Clients bought this shoe,</strong>{' '}
      <br className="d-none d-md-block" /> Maybe try this one too
    </>
  ),
  sec11Button1Text: 'Women',
  sec11Button2Text: 'Men',
  sec11Button1Url: '#',
  sec11Button2Url: '#',
}

export default LandingPageWoodSneaker2
